export default {
  title: 'Dodaj kartę kredytową',
  buttons: {
    save: 'Zapisz',
  },
  feedback: {
    success: 'Karta dodana pomyślnie',
  },
};
